module.exports = __webpack_public_path__ + "img/award-ms.0cb6f807.png";